module.exports = __webpack_public_path__ + "assets/img/06-m.7e30ffb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/06-m.jpg
// module id = KQJu
// module chunks = 0